import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import useIsMobile from "../utils/useIsMobile";

const BottomMobileNav = () => {
  const isMobile = useIsMobile();
  const { userInfo } = useSelector((state) => state.userLogin);

  if (!isMobile || !userInfo) return null;

  return (
    <nav className="bottom-mobile-nav">
      <NavLink exact to="/billing" className="bottom-nav-item" activeClassName="active">
        <i className="fa fa-file-text"></i>
        <span>TRF</span>
      </NavLink>
      <NavLink exact to="/bookings" className="bottom-nav-item" activeClassName="active">
        <i className="fa fa-calendar"></i>
        <span>Bookings</span>
      </NavLink>
      <NavLink exact to="/daily-book" className="bottom-nav-item" activeClassName="active">
        <i className="fa fa-book"></i>
        <span>Day Book</span>
      </NavLink>
      <NavLink exact to="/reports" className="bottom-nav-item" activeClassName="active">
        <i className="fa fa-bar-chart"></i>
        <span>Reports</span>
      </NavLink>
    </nav>
  );
};

export default BottomMobileNav;
